/**
 * Corrige texto con doble-encoding Latin-1/UTF-8.
 * Ocurre cuando datos del proveedor (Ã¡ → á, Ã³ → ó, etc.)
 * fueron almacenados con encoding incorrecto.
 * Solo actúa si detecta el patrón roto (Ã o Â).
 */
const fixEncoding = (str) => {
  if (!str || !/Ã|Â/.test(str)) return str;
  try {
    const bytes = new Uint8Array([...str].map(c => c.charCodeAt(0) & 0xFF));
    return new TextDecoder('utf-8').decode(bytes);
  } catch {
    return str;
  }
};

export default fixEncoding;
